<template>
    <div class="row entity-content">
        <div class="col-12">
            <div class="row">
                <div class="col-12">
                    <template v-if="normalAction">
                        <MaterialInput
                            :readonly="readonlyForm"
                            :disabled="readonlyForm"
                            class="city-form-group city-bg"
                            id="input-entity_name"
                            name="entity_name"
                            v-model.trim="form.name"
                            v-validate="rulesField('name', { required: true })"
                            :data-vv-scope="vScope"
                            :inputClasses="[{ 'is-invalid': fnHasError('entity_name', vScope) }]"
                            :error="fnFirstError('entity_name', vScope)"
                        >
                            {{ $t(`${modelTranslateID}.name`) }}
                        </MaterialInput>
                    </template>
                    <template v-else>
                        <MaterialSelect
                            :disabled="readonlyForm"
                            class="city-form-group city-bg"
                            :id="`input-entity_name`"
                            :name="`entity_name`"
                            :noWrap="false"
                            v-model.trim="form[entityLabel]"
                            :initialData="form"
                            @selected="onSelectedEntity"
                            @cleared="onClearedEntity"
                            @created="onCreated"
                            :data-vv-scope="vScope"
                            v-validate="rulesField('entity_name', { required: true })"
                            :inputClasses="[{ 'is-invalid': fnHasError(`entity_name`, vScope) }]"
                            :error="fnFirstError(`entity_name`, vScope)"
                            :label="entityLabel"
                            :ajaxOptions="{
                                url: url.lookup,
                                urlParams: { model: 'entities', id: form.entity_id },
                                shouldLoadDataOnDropdownOpen: true
                            }"
                             :reduce="onption => onption[entityLabel]"
                            :allowCreate="true"
                            :templateCreate="label => $t(`${modelTranslateID}.templateCreate`, { label: label })"
                        >
                            {{ $t(`${modelTranslateID}.name`) }}
                        </MaterialSelect>
                    </template>
                </div>
            </div>

            <div
                class="row"
                v-if="showProperties"
            >
                <div class="col-12 col-sm-6 col-md-5">
                    <MaterialInput
                        autocomplete="new-email"
                        :readonly="entityReadonlyForm"
                        :disabled="entityReadonlyForm"
                        type="email"
                        class="city-form-group city-bg"
                        id="input-entity_email"
                        name="entity_email"
                        v-model.trim="form.email"
                        v-lowercase
                        v-validate="rulesField('phone', { email: true })"
                        :data-vv-scope="vScope"
                        :inputClasses="[{ 'is-invalid': fnHasError('entity_email', vScope) }]"
                        :error="fnFirstError('entity_email', vScope)"
                    >
                        {{ $t(`${modelTranslateID}.email`) }}
                    </MaterialInput>
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                    <MaterialInput
                        autocomplete="new-phone"
                        :readonly="entityReadonlyForm"
                        :disabled="entityReadonlyForm"
                        class="city-form-group city-bg"
                        id="input-entity_phone"
                        name="entity_phone"
                        v-model.trim="form.phone"
                        v-validate="rulesField('phone', { numeric: true, min_value: 1, min: 9, max: 14 })"
                        :data-vv-scope="vScope"
                        :inputClasses="[{ 'is-invalid': fnHasError('entity_phone', vScope) }]"
                        :error="fnFirstError('entity_phone', vScope)"
                    >
                        {{ $t(`${modelTranslateID}.phone`) }}
                    </MaterialInput>
                </div>
                <div class="col-12 col-sm-5 col-md-3">
                    <MaterialInput
                        :readonly="entityReadonlyForm"
                        :disabled="entityReadonlyForm"
                        class="city-form-group city-bg"
                        id="input-entity_tax_number"
                        name="entity_tax_number"
                        v-model.trim="form.tax_number"
                        v-validate="rulesField('tax_number', { nif: { countryCode: countryCodeNIF } })"
                        :data-vv-scope="vScope"
                        :inputClasses="[{ 'is-invalid': fnHasError('entity_tax_number', vScope) }]"
                        :error="fnFirstError('entity_tax_number', vScope)"
                    >
                        {{ $t(`${modelTranslateID}.tax_number`) }}
                    </MaterialInput>
                </div>

                <div class="col-12 col-sm-7 col-md-6">
                    <MaterialSelect
                        :disabled="entityReadonlyForm"
                        class="city-form-group city-bg"
                        id="input-entity_gender"
                        name="entity_gender"
                        label="name"
                        v-model.trim="form.gender_id"
                        :options="genders"
                        v-validate="rulesField('cemetery_id', { required: true })"
                        :data-vv-scope="vScope"
                        :inputClasses="[{ 'is-invalid': fnHasError('entity_gender', vScope) }]"
                        :error="fnFirstError('entity_gender', vScope)"
                    >
                        {{ $t(`${modelTranslateID}.gender`) }}
                    </MaterialSelect>
                </div>
                <div class="col-12 col-sm-12 col-md-6">
                    <MaterialSelect
                        :disabled="entityReadonlyForm"
                        class="city-form-group city-bg"
                        id="input-entity_religion"
                        name="entity_religion"
                        label="name"
                        v-model.trim="form.religion_type_id"
                        :options="religions"
                        v-validate="rulesField('religion_type_id')"
                        :data-vv-scope="vScope"
                        :inputClasses="[{ 'is-invalid': fnHasError('entity_religion', vScope) }]"
                        :error="fnFirstError('entity_religion', vScope)"
                    >
                        {{ $t(`${modelTranslateID}.religion`) }}
                    </MaterialSelect>
                </div>

                <div class="col-12 col-sm-4 col-md-5">
                    <MaterialDatePicker
                        :disabled="readonlyForm"
                        class="city-form-group city-bg"
                        id="input-entity_birth_at"
                        name="entity_birth_at"
                        v-model.trim="form.birth_at"
                        :dateFormat="labelDateFormat"
                        :databaseDateFormat="dateFormat"
                        v-validate="''"
                        :data-vv-scope="vScope"
                        :inputClasses="[{ 'is-invalid': fnHasError('entity_birth_at', vScope) }]"
                        :error="fnFirstError('entity_birth_at', vScope)"
                    >
                        {{ $t(`${modelTranslateID}.birth_at`) }}
                    </MaterialDatePicker>
                </div>
                <div class="col-12 col-sm-4 col-md-5">
                    <MaterialDatePicker
                        :disabled="readonlyForm"
                        class="city-form-group city-bg"
                        id="input-entity_death_at"
                        name="entity_death_at"
                        v-model.trim="form.death_at"
                        :dateFormat="labelDateFormat"
                        :databaseDateFormat="dateFormat"
                        v-validate="rulesField('death_at', { dateAfter: [form.birth_at, true, $t(`${modelTranslateID}.birth_at`)] })"
                        :data-vv-scope="vScope"
                        :inputClasses="[{ 'is-invalid': fnHasError('entity_death_at', vScope) }]"
                        :error="fnFirstError('entity_death_at', vScope)"
                    >
                        {{ $t(`${modelTranslateID}.death_at`) }}
                    </MaterialDatePicker>
                </div>
                <div class="col-12 col-sm-4 col-md-2">
                    <MaterialInput
                        :readonly="true"
                        :disabled="true"
                        class="city-form-group city-bg"
                        id="input-entity_age"
                        name="entity_age"
                        :value="age"
                        :data-vv-scope="vScope"
                    >
                        {{ $t(`${modelTranslateID}.age`) }}
                    </MaterialInput>
                </div>

                <div class="col-12 col-sm-12 col-md-4">
                    <MaterialInput
                        :readonly="entityReadonlyForm"
                        :disabled="entityReadonlyForm"
                        class="city-form-group city-bg"
                        id="input-entity_father"
                        name="entity_father"
                        v-model.trim="form.father_affiliation"
                        v-validate="rulesField('father_affiliation')"
                        :data-vv-scope="vScope"
                        :inputClasses="[{ 'is-invalid': fnHasError('entity_father', vScope) }]"
                        :error="fnFirstError('entity_father', vScope)"
                    >
                        {{ $t(`${modelTranslateID}.father_affiliation`) }}
                    </MaterialInput>
                </div>
                <div class="col-12 col-sm-12 col-md-4">
                    <MaterialInput
                        :readonly="entityReadonlyForm"
                        :disabled="entityReadonlyForm"
                        class="city-form-group city-bg"
                        id="input-entity_mother"
                        name="entity_mother"
                        v-model.trim="form.mother_affiliation"
                        v-validate="rulesField('mother_affiliation')"
                        :data-vv-scope="vScope"
                        :inputClasses="[{ 'is-invalid': fnHasError('entity_mother', vScope) }]"
                        :error="fnFirstError('entity_mother', vScope)"
                    >
                        {{ $t(`${modelTranslateID}.mother_affiliation`) }}
                    </MaterialInput>
                </div>
                <div class="col-12 col-sm-12 col-md-4">
                    <MaterialInput
                        :readonly="entityReadonlyForm"
                        :disabled="entityReadonlyForm"
                        class="city-form-group city-bg"
                        id="input-entity_occupation"
                        name="entity_occupation"
                        v-model.trim="form.occupation"
                        v-validate="rulesField('entity_occupation')"
                        :data-vv-scope="vScope"
                        :inputClasses="[{ 'is-invalid': fnHasError('entity_occupation', vScope) }]"
                        :error="fnFirstError('entity_occupation', vScope)"
                    >
                        {{ $t(`${modelTranslateID}.occupation`) }}
                    </MaterialInput>
                </div>

                <div class="col-12 col-sm-12 col-md">
                    <MaterialSelect
                        :disabled="entityReadonlyForm"
                        class="city-form-group city-bg"
                        id="input-entity_cause_death"
                        name="entity_cause_death"
                        label="name"
                        v-model.trim="form.cause_death_type_id"
                        :options="causes_death"
                        v-validate="rulesField('cause_death_type_id')"
                        :data-vv-scope="vScope"
                        :inputClasses="[{ 'is-invalid': fnHasError('entity_cause_death', vScope) }]"
                        :error="fnFirstError('entity_cause_death', vScope)"
                    >
                        {{ $t(`${modelTranslateID}.cause_death`) }}
                    </MaterialSelect>
                </div>
                <div class="col-12 col-sm-auto align-self-center form-group">
                    <div class="form-check city-form-check form-check-inline">
                        <input
                            :readonly="entityReadonlyForm"
                            :disabled="entityReadonlyForm"
                            class="city-form-group city-bg"
                            type="checkbox"
                            id="input-use_personal_data"
                            name="use_personal_data"
                            v-model.trim="form.use_personal_data"
                            :false-value="false"
                            :true-value="true"
                        />
                        <label
                            class="form-check-label h-auto"
                            :for="`input-use_personal_data`"
                        >
                            <div class="d-flex flex-column align-items-start">
                                <span> {{ $t(`${modelTranslateID}.use_personal_data`) }}</span>
                            </div>
                        </label>
                    </div>
                </div>

                <div class="col-12 address">
                    <h6 class="header">{{ $t(`${translateID}.form.${addressTitle}`) }}</h6>

                    <div class="row">
                        <div class="col-12 col-sm-12">
                            <MaterialInput
                                :readonly="entityReadonlyForm"
                                :disabled="entityReadonlyForm"
                                class="city-form-group city-bg"
                                id="input-entity_address"
                                name="entity_address"
                                v-model.trim="form.address"
                                v-validate="rulesField('entity_address', { min: 3 })"
                                :data-vv-scope="vScope"
                                :inputClasses="[{ 'is-invalid': fnHasError('entity_address', vScope) }]"
                                :error="fnFirstError('entity_address', vScope)"
                            >
                                {{ $t(`${modelTranslateID}.address`) }}
                            </MaterialInput>
                        </div>
                        <div class="col-12 col-sm-6">
                            <MaterialInput
                                :readonly="entityReadonlyForm"
                                :disabled="entityReadonlyForm"
                                class="city-form-group city-bg"
                                id="input-entity_locality"
                                name="entity_locality"
                                v-model.trim="form.locality"
                                v-validate="rulesField('entity_locality')"
                                :data-vv-scope="vScope"
                                :inputClasses="[{ 'is-invalid': fnHasError('entity_locality', vScope) }]"
                                :error="fnFirstError('entity_locality', vScope)"
                            >
                                {{ $t(`${modelTranslateID}.locality`) }}
                            </MaterialInput>
                        </div>
                        <div class="col-12 col-sm-6">
                            <MaterialInput
                                :readonly="entityReadonlyForm"
                                :disabled="entityReadonlyForm"
                                class="city-form-group city-bg"
                                id="input-entity_postal_code"
                                name="entity_postal_code"
                                v-model.trim="form.postal_code"
                                v-validate="rulesField('entity_postal_code', { min: 8, max: 8, regex: /^\d{4}-\d{3}$/ })"
                                :data-vv-scope="vScope"
                                :inputClasses="[{ 'is-invalid': fnHasError('entity_postal_code', vScope) }]"
                                :error="fnFirstError('entity_postal_code', vScope)"
                            >
                                {{ $t(`${modelTranslateID}.postal_code`) }}
                            </MaterialInput>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FormElementMixin from "../mixins/FormElementMixin";
import { customMergeDeep,nullify } from "@config/utils";
import { ENTITY_FORM_ACTIONS } from "../../../../shared/config/constants";

export default {
    mixins: [FormElementMixin],
    components: {
        MaterialDatePicker: () => import(/* webpackChunkName: "datepicker" */ "@/components/form/MaterialDatePicker")
    },
    props: {
        addressTitle: {
            type: String,
            default: "address"
        },
        genders: {
            type: Array,
            default: () => {
                return [];
            }
        },
        religions: {
            type: Array,
            default: () => {
                return [];
            }
        },
        causes_death: {
            type: Array,
            default: () => {
                return [];
            }
        },
        action: {
            type: String,
            default: ENTITY_FORM_ACTIONS.NORMAL,
            validator: val => {
                return val && Object.values(ENTITY_FORM_ACTIONS).includes(val);
            }
        }
    },
    data() {
        return { entityLabel: "name"};
    },
    computed: {
        normalAction() {
            return this.action == ENTITY_FORM_ACTIONS.NORMAL;
        },
        onlySelectAction() {
            return this.action == ENTITY_FORM_ACTIONS.ONLY_SELECT;
        },
        onlySelectAndViewAction() {
            return this.action == ENTITY_FORM_ACTIONS.ONLY_SELECT_AND_VIEW;
        },
        showProperties() {
            return this.normalAction || this.onlySelectAndViewAction;
        },
        entityReadonlyForm() {
            return this.onlySelect || this.onlySelectAndView ? true : this.readonlyForm;
        },
        registerConfig() {
            return this.$store.getters.registerConfig ?? {};
        },
        countryCodeNIF() {
            return this.registerConfig?.nif?.country_code ?? "PT";
        },
        age() {
            let birth_at = this.form?.birth_at ?? null;
            let death_at = this.form?.death_at ?? null;

            if (birth_at && death_at) {
                let years = moment(death_at).diff(birth_at, "years", false);
                return years > -1 ? years : null;
            }
            return null;
        }
    },
    methods: {
        onSelectedEntity(item) {
            customMergeDeep(this.form, item ?? {});
        },
        onClearedEntity() {
            Object.keys(this.form).forEach(k => (this.form[k] = null));
        },
        onCreated(item) {
            nullify(this.form);
            this.form.status = true;
            this.form.use_personal_data = true;
            this.form[this.entityLabel] = item?.name;
        }
    },
    watch: {}
};
</script>

<style lang="scss" scoped>
.entity-content {
    font-family: var(--city-font-family);
    .address {
        .header {
            margin-top: 20px;
            margin-bottom: 12px;
            font-size: 14px;
            line-height: 16px;
            font-weight: 500;
            color: var(--primary-color);
        }
    }
}
</style>
